

import React, { useContext, useState } from 'react';
import AuthContext from 'app/AuthContext';
import { FormModal, ResetPasswordForm } from 'sub-components';

const ResetPasswordModal = (props) => {
    const [actionCompleted, setActionCompleted] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);

    const handleActionCompleted = () => {
        setActionCompleted(true);
    };

    return (
        <FormModal
            isToggleOn={props.isResetPwdToggleOn}
            handleClick={props.handleClick}
            onClose={() => {
                clearTimeout(timeoutId);
                setActionCompleted(false);
            }}
            actionCompleted={actionCompleted}
            title="Reset Password"
            successfulActionTitle="Reset Password Link Sent!"
            successfulActionMessage={
                <div>
                    Please check your email for the reset password link.
                </div>
            }
        >
            <ResetPasswordForm onActionCompleted={handleActionCompleted} handleCloseModal={props.handleClick} />
        </FormModal>
    );
};

export default ResetPasswordModal;